<template>
  <div class="w-full border rounded-lg overflow-hidden bg-white animate-pulse mt-4">
    <div class="flex items-center gap-4 bg-gray-50 px-6 py-4 border-b border-gray-200">
      <div class="h-4 w-6 bg-slate-200 rounded"></div>
      <div v-for="n in 6" :key="`head-${n}`" class="h-4 bg-slate-200 rounded flex-1"></div>
    </div>

    <div class="flex flex-col">
      <div
        v-for="row in 20"
        :key="`row-${row}`"
        class="flex items-center gap-4 px-6 py-4 border-b border-gray-100 last:border-0 hover:bg-gray-50"
      >
        <div class="h-4 w-6 bg-slate-200 rounded"></div>
        <div class="h-4 w-12 bg-slate-200 rounded"></div>
        <div class="h-4 flex-[2] bg-slate-200 rounded"></div>
        <div class="h-4 flex-1 bg-slate-200 rounded"></div>
        <div class="h-4 flex-1 bg-slate-200 rounded"></div>
        <div class="h-4 flex-1 bg-slate-200 rounded"></div>
        <div class="h-4 flex-[1.5] bg-slate-200 rounded"></div>
        <div class="h-4 flex-1 hidden md:block bg-slate-200 rounded"></div>
      </div>
    </div>

    <div class="flex justify-center items-center py-4 border-t border-gray-200">
      <div class="h-8 w-64 bg-slate-200 rounded-full"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
